import React from "react";
import { CardPaddingType, CardProps } from "../types";
import { Pad } from "./Pad";

export const CardSection = ({
  children, ...rest
}: Partial<CardProps> & CardPaddingType) => {
  return <Pad {...rest}>{children}</Pad>;
};
